import React from 'react'


    const ProgressSide = ({done}) => {
        const [style, setStyle] = React.useState({});
        
        setTimeout(() => {
            const newStyle = {
                opacity: 1,
                width: `${done}%`
            }
            
            setStyle(newStyle);
        }, 200);
        
        return (
            <div className="main-side">
            <div className="pro-side">
                <div className="progress-done" style={style}>
                </div>
            </div>
            </div>
        )
    }
    
  export default ProgressSide;


//   const Div = styled.div `
//  .pro-side{
//     &:nth-child(3){
//     background-color: #1e1e2f !important;
//   }
//  }
//   `;

